// Chakra imports
import { Box, Icon, SimpleGrid, useColorModeValue } from "@chakra-ui/react";
// Custom components

import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import { MdOutlineTerminal } from "react-icons/md";
import { FaBuilding } from "react-icons/fa";
import ComplexTable from "views/admin/default/components/ComplexTable";
import VersionsCard from "./components/VersionGraphic";
import CTRCard from "./components/CTRGraphic";
import TefCard from "./components/TefGraphic";
import { useQuery } from "react-query";
import { UseDashboard } from "hooks/DashboardHook";

export default function UserReports() {
  // Chakra Color Mode
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const { findCardsDashboard } = UseDashboard();

  const { data, isLoading } = useQuery("cardDashData", findCardsDashboard);

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 2, "2xl": 2 }}
        gap="20px"
        mb="20px"
      >
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={FaBuilding} color={brandColor} />
              }
            />
          }
          name="Empreas"
          value={data?.cards?.companys}
          loading={isLoading}
        />

        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon
                  w="32px"
                  h="32px"
                  as={MdOutlineTerminal}
                  color={brandColor}
                />
              }
            />
          }
          name="Terminais"
          value={data?.cards?.terminals}
          loading={isLoading}
        />
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap="20px" mb="20px">
        <ComplexTable />
        <VersionsCard name="CHECKOUT" />
        <VersionsCard name="RETAGUARDA" />
				<VersionsCard name="INTEGRADORPDVS" />
        <TefCard name="TEF" />
        <CTRCard name="REGIME TRIBUTARIO" />
      </SimpleGrid>
    </Box>
  );
}
